/**
 * @file technical-details.tsx
 * @module app/modules/uProcure/products/edit-master-product/technical-details
 * @description Implements the technical details interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { CustomSelectWhite } from '../../../../custom/Select/CustomSelectWhite';
import {
  MultiLineText,
  MultiSelection,
  SingleLineText,
  SingleSelection,
  DateSelection,
} from '../../../../../utils/constants';
import clsx from 'clsx';
import CustomDatePicker from '../../../../custom/DateRange/DatePicker';
import Method from '../../../../../utils/methods';
import ImageWithFallback from '../../../_common/components/image-with-fallback';
const TechnicalDetails = (props: any) => {
  const [startDate, setStartDate] = useState<any>(new Date());
  const [generalData, setGeneralData] = useState<any>(props.generalData);
  const [generalDataValidation, setGeneralDataValidation] = useState<any>(
    props.validations
  );
  const handleChange = (value: any, techIndex: number) => {
    let temp: any = { ...generalData };
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    if (value.length > 0) {
      validationTemp.defaultTechnicalFields[techIndex]['valid'] = false;
    } else {
      validationTemp.defaultTechnicalFields[techIndex]['valid'] = true;
    }
    // temp[name] = value;
    // temp.defaultTechnicalFields[techIndex] = { answer: value };
    temp.defaultTechnicalFields[techIndex]['answer'] = value;
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  const handleMultipleChange = (event: any, techIndex: number) => {
    let temp: any = JSON.parse(JSON.stringify({ ...generalData }));
    let data: any = [];
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    if (event.length) {
      validationTemp.defaultTechnicalFields[techIndex]['valid'] = false;
    } else {
      validationTemp.defaultTechnicalFields[techIndex]['valid'] = true;
    }
    event.map((val: any) => {
      return data.push(val._id);
    });
    setGeneralDataValidation(validationTemp);
    temp.defaultTechnicalFields[techIndex]['selectedOptions'] = data;
    setGeneralData(temp);
  };
  const handleSingleChange = (event: any, techIndex: number) => {
    let temp: any = { ...generalData };
    let data: any = [];
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    validationTemp.defaultTechnicalFields[techIndex]['valid'] = false;
    data.push(event._id);
    temp.defaultTechnicalFields[techIndex]['selectedOptions'] = data;
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  const handleTechnicalInfoSeperated = (value: boolean) => {
    let temp: any = { ...generalData };
    let data: any = [];
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    validationTemp.overrideVariantsTechnicalInfo = false;
    temp.overrideVariantsTechnicalInfo = value;
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  const handleDateChange = (value: any, techIndex: number) => {
    setStartDate(value);
    let temp: any = { ...generalData };
    let validationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    if (value.length > 0) {
      validationTemp.defaultTechnicalFields[techIndex]['valid'] = false;
    } else {
      validationTemp.defaultTechnicalFields[techIndex]['valid'] = true;
    }
    // temp[name] = value;
    // temp.defaultTechnicalFields[techIndex] = { answer: value };
    temp.defaultTechnicalFields[techIndex]['answer'] = value;
    setGeneralDataValidation(validationTemp);
    setGeneralData(temp);
  };
  useEffect(() => {
    props.onGeneralDataChange(generalData);
  }, [generalData, props]);
  useEffect(() => {
    props.onValidationChange(generalDataValidation);
  }, [generalDataValidation]);
  return (
    <>
      <Card className="bg-light mb-6 mb-xl-9 border">
        <div className="card-body">
          {generalData.defaultTechnicalFields.length > 0 ? (
            generalData.defaultTechnicalFields.map(
              (techVal: any, techIndex: number) => {
                if (techVal.type === SingleLineText) {
                  return (
                    <Row className={clsx('align-items-center mb-5')}>
                      <Col lg={2}>
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        <input
                          type="text"
                          className={clsx(
                            'form-control form-control-custom bg-white',
                            generalDataValidation.defaultTechnicalFields[
                              techIndex
                            ]['valid']
                              ? 'border-danger'
                              : ''
                          )}
                          placeholder="Type here…"
                          value={techVal?.answer}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value.trimStart(),
                              techIndex
                            );
                          }}
                        />
                      </Col>
                    </Row>
                  );
                }
                if (techVal.type === SingleSelection) {
                  return (
                    <Row className="align-items-center mb-5">
                      <Col lg={2}>
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        <CustomSelectWhite
                          options={techVal.options}
                          getOptionLabel={(option: any) => {
                            return option.title;
                          }}
                          border={
                            generalDataValidation.defaultTechnicalFields[
                              techIndex
                            ]['valid']
                              ? '#e55451'
                              : ''
                          }
                          defaultValue={techVal.options.find((val: any) => {
                            return (
                              techVal.selectedOptions &&
                              techVal.selectedOptions.includes(val._id)
                            );
                          })}
                          isMulti={false}
                          onChange={(event: any) => {
                            handleSingleChange(event, techIndex);
                          }}
                          isSearchable={false}
                        />
                      </Col>
                    </Row>
                  );
                }
                if (techVal.type === MultiLineText) {
                  return (
                    <Row className="align-items-center mb-5">
                      <Col
                        lg={2}
                        className="align-self-lg-start mt-lg-2"
                      >
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        <Form.Control
                          className={clsx(
                            'form-control-custom border bg-white',
                            generalDataValidation.defaultTechnicalFields[
                              techIndex
                            ]['valid']
                              ? 'border-danger'
                              : ''
                          )}
                          placeholder="Type here…"
                          as="textarea"
                          rows={4}
                          value={techVal?.answer}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value.trimStart(),
                              techIndex
                            );
                          }}
                        />
                      </Col>
                    </Row>
                  );
                }
                if (techVal.type === MultiSelection) {
                  return (
                    <Row className="align-items-center mb-5">
                      <Col lg={2}>
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        <CustomSelectWhite
                          // options={techVal.options}
                          // // defaultValue={techVal.options.find((val: any) => {
                          // //   return (
                          // //     techVal.selectedOptions &&
                          // //     techVal.selectedOptions.includes(val._id)
                          // //   );
                          // // })}
                          // getOptionLabel={(option: any) => {
                          //   return option.title;
                          // }}
                          // // value={
                          // //   techVal.selectedOptions &&
                          // //   techVal.selectedOptions.map(
                          // //     (optionVal: any, optionIndex: number) => {
                          // //       return optionVal;
                          // //     }
                          // //   )
                          // // }
                          // isMulti={true}
                          // onChange={(event: any) => {
                          //   handleMultipleChange(event, techIndex);
                          // }}
                          // hideSelectedOptions={false}
                          value={
                            techVal.selectedOptions &&
                            techVal.selectedOptions.length &&
                            techVal.selectedOptions
                              .map((selectedOptionId: any) => {
                                const option = techVal.options.find(
                                  (option: any) =>
                                    option._id === selectedOptionId
                                );
                                if (option) {
                                  return {
                                    title: option.title,
                                    label: option.title,
                                    _id: option._id,
                                    value: option._id,
                                  };
                                }
                                return null;
                              })
                              .filter((option: any) => option !== null)
                          }
                          border={
                            generalDataValidation.defaultTechnicalFields[
                              techIndex
                            ]['valid']
                              ? '#e55451'
                              : ''
                          }
                          options={
                            techVal.options?.length &&
                            techVal.options.map((val: any, index: number) => {
                              return {
                                title: val.title,
                                label: val.title,
                                _id: val._id,
                                value: val._id,
                              };
                            })
                          }
                          loadingMessage={'Fetching Data'}
                          isMulti={true}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ): void => handleMultipleChange(e, techIndex)}
                          isSearchable={false}
                        />
                      </Col>
                    </Row>
                  );
                }
                if (techVal.type === DateSelection) {
                  return (
                    <Row className={clsx('align-items-center mb-5')}>
                      <Col lg={2}>
                        <label
                          htmlFor=""
                          className="fs-16 fw-500 mb-lg-0 mb-3"
                        >
                          {techVal?.name}
                        </label>
                      </Col>
                      <Col lg={10}>
                        {/* <input
                          type="text"
                          className={clsx(
                            "form-control form-control-custom bg-white",
                            generalDataValidation.defaultTechnicalFields[
                              techIndex
                            ]["valid"]
                              ? "border-danger"
                              : ""
                          )}
                          placeholder="Type here…"
                          value={techVal?.answer}
                          onChange={(event: any) => {
                            handleChange(
                              event.target.value.trimStart(),
                              techIndex
                            );
                          }}
                        /> */}
                        <CustomDatePicker
                          className="bg-white min-h-50px text-dark min-w-md-204px min-w-175px"
                          selected={
                            techVal.answer && techVal.answer !== 'undefined'
                              ? new Date(techVal.answer)
                              : new Date()
                          }
                          onChange={(e: any): void =>
                            handleDateChange(e, techIndex)
                          }
                          // selectsRange
                          startDate={
                            techVal.answer && techVal.answer !== 'undefined'
                              ? new Date(techVal.answer)
                              : new Date()
                          }
                          dateFormat="dd/MM/yyyy"
                          showFullMonthYearPicker
                          inputTextBG="bg-white"
                        />
                      </Col>
                    </Row>
                  );
                }
              }
            )
          ) : (
            <>
              <div className="h-150px w-100 align-items-center d-flex justify-content-center">
                <span className="fs-22 text-dark fw-600">
                  No technical fields available
                </span>
              </div>
            </>
          )}
        </div>
      </Card>
      {generalData.variantsUsingSeparateInfo.length ? (
        <Card className="bg-light mb-6 mb-xl-9 border">
          <Card.Header className="border-bottom-0">
            <Card.Title className="fs-20 fw-600">
              Would you like to override technical details for the following
              product variations?
            </Card.Title>
          </Card.Header>
          <Card.Body className="pt-0">
            <Row>
              <Col xs="auto">
                <div className="form-check form-check-custom form-check-solid form-check-lg">
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    value=""
                    id="flexCheckboxLg"
                    checked={generalData.overrideVariantsTechnicalInfo}
                    onClick={() => {
                      handleTechnicalInfoSeperated(
                        !generalData.overrideVariantsTechnicalInfo
                      );
                    }}
                  />
                  <label
                    className="form-check-label fs-16 fw-600 text-dark"
                    htmlFor="flexCheckboxLg"
                  >
                    Yes
                  </label>
                </div>
              </Col>
              <Col xs="auto">
                <div className="form-check form-check-custom form-check-solid form-check-lg">
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    value=""
                    id="flexCheckboxLg"
                    checked={!generalData.overrideVariantsTechnicalInfo}
                    onClick={() => {
                      handleTechnicalInfoSeperated(
                        !generalData.overrideVariantsTechnicalInfo
                      );
                    }}
                  />
                  <label
                    className="form-check-label fs-16 fw-600 text-dark"
                    htmlFor="flexCheckboxLg"
                  >
                    No
                  </label>
                </div>
              </Col>
              <Col
                xs={12}
                className="mt-9"
              >
                <Row className="align-items-center g-6">
                  {generalData.variantsUsingSeparateInfo.map((combVal: any) => {
                    return (
                      <Col
                        md={5}
                        lg={3}
                      >
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <div className="symbol symbol-50px bg-white border">
                              <ImageWithFallback
                                className="object-fit-contain"
                                src={combVal.variant.media[0].url}
                                alt="..."
                                noDefaultSize
                              />
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3 fs-15 fw-600">
                            {combVal.variant.title}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ) : (
        <></>
      )}
    </>
  );
};
export default TechnicalDetails;
